import { Injectable } from '@angular/core';
import { FiDropdownItemDisabledFn } from 'Source/app/shared/fi-select-search/fi-select-search';
import { TItemWithChildren } from 'Source/app/shared/fi-select-search/select-search-base';
import { isDefined } from 'Source/app/shared/utils';

interface IFilterItemsArgs<T> {
    items: TItemWithChildren<T>[];
    searchText: string;
    displayValue: string;
    externalFilterFn: FiDropdownItemDisabledFn<T>;
    isSearchAmongChildren?: boolean;
}

@Injectable()
export class FiMenuMultiSelectItemSearchHelperService {
    getFilteredItems<T>(args: IFilterItemsArgs<T>): T[] {
        if (!isDefined(args.searchText) && !isDefined(args.externalFilterFn)) {
            return args.items;
        }

        return args.items.filter((item) => {
            if (args.isSearchAmongChildren) {
                if (this.isSearchTextExcludedInChildren(item, args)) {
                    return false;
                }
            } else {
                if (this.isSearchTextExcludedInItemAndChildren(item, args)) {
                    return false;
                }
            }

            if (args.externalFilterFn) {
                return args.externalFilterFn(item, args.items);
            }
            return true;
        });
    }

    private isSearchTextExcludedInChildren<T>(item: TItemWithChildren<T>, args: IFilterItemsArgs<T>): boolean {
        return args.searchText && !item.ChildItems.some((childItem) => this.isItemIncludesSearch(childItem, args));
    }

    private isSearchTextExcludedInItemAndChildren<T>(item: TItemWithChildren<T>, args: IFilterItemsArgs<T>): boolean {
        return (
            args.searchText &&
            !this.isItemIncludesSearch(item, args) &&
            !item.ChildItems.some((childItem) => this.isItemIncludesSearch(childItem, args))
        );
    }

    private isItemIncludesSearch<T>(item: TItemWithChildren<T>, args: IFilterItemsArgs<T>): boolean {
        return item[args.displayValue].toLowerCase().includes(args.searchText.toLowerCase());
    }
}
